import { useState } from 'react'
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { cabApi } from '../../services/api'
import toast from 'react-hot-toast'
import { Plus, Trash2, Printer } from 'lucide-react'
import { useConfirmDelete } from '../../hooks/useConfirmDelete'

export default function CabStampanti() {
  const qc = useQueryClient()
  const { confirmDelete, ConfirmModal } = useConfirmDelete()
  const [showForm, setShowForm] = useState(false)
  const [nuova, setNuova] = useState({ nome: '', host: '', porta: '9100', dpi: '300' })
  const [afor, setAfor] = useState('')

  const { data: stampanti = [], isLoading } = useQuery({ queryKey: ['cab-stampanti'], queryFn: () => cabApi.stampanti.list().then(r => r.data) })
  const { data: impostazioni } = useQuery({
    queryKey: ['cab-impostazioni'],
    queryFn: () => cabApi.impostazioni.get().then(r => r.data).catch(() => null),
  })

  const createMut = useMutation({
    mutationFn: () => cabApi.stampanti.create({ ...nuova, porta: parseInt(nuova.porta, 10), dpi: parseInt(nuova.dpi, 10) }),
    onSuccess: () => { qc.invalidateQueries({ queryKey: ['cab-stampanti'] }); setShowForm(false); toast.success('Stampante creata') },
    onError: (e: any) => toast.error(e?.response?.data?.detail || 'Errore'),
  })
  const deleteMut = useMutation({
    mutationFn: (id: number) => cabApi.stampanti.remove(id),
    onSuccess: () => { qc.invalidateQueries({ queryKey: ['cab-stampanti'] }); toast.success('Eliminata') },
  })
  const testMut = useMutation({
    mutationFn: (id: number) => cabApi.stampanti.test(id),
    onSuccess: () => toast.success('Stampa di prova inviata'),
    onError: (e: any) => toast.error(e?.response?.data?.detail || 'Errore invio'),
  })
  const impostazioniMut = useMutation({
    mutationFn: () => cabApi.impostazioni.update({ afor }),
    onSuccess: () => { qc.invalidateQueries({ queryKey: ['cab-impostazioni'] }); toast.success('Impostazioni salvate') },
  })

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-lg font-semibold text-slate-900">Stampanti e Impostazioni CAB</h1>
      </div>

      <div className="card p-4 max-w-md space-y-2">
        <label className="label">AFOR (codice Riparatore)</label>
        <div className="flex gap-2">
          <input className="input font-mono" maxLength={4} value={afor || impostazioni?.afor || ''} onChange={e => setAfor(e.target.value.toUpperCase())} />
          <button className="btn-primary" disabled={!afor || impostazioniMut.isPending} onClick={() => impostazioniMut.mutate()}>Salva</button>
        </div>
        {impostazioni?.afor && <p className="text-xs text-slate-400">Attuale: {impostazioni.afor}</p>}
      </div>

      <div className="flex items-center justify-between">
        <h2 className="text-sm font-semibold text-slate-600">Stampanti</h2>
        <button className="btn-primary flex items-center gap-1.5" onClick={() => setShowForm(v => !v)}><Plus size={14} /> Nuova</button>
      </div>

      {showForm && (
        <div className="card p-4 grid grid-cols-2 sm:grid-cols-5 gap-2 items-end">
          <div><label className="label">Nome</label><input className="input" value={nuova.nome} onChange={e => setNuova(p => ({ ...p, nome: e.target.value }))} /></div>
          <div><label className="label">Host (IP privato)</label><input className="input" value={nuova.host} onChange={e => setNuova(p => ({ ...p, host: e.target.value }))} /></div>
          <div><label className="label">Porta</label><input className="input w-24" value={nuova.porta} onChange={e => setNuova(p => ({ ...p, porta: e.target.value }))} /></div>
          <div><label className="label">DPI</label>
            <select className="select" value={nuova.dpi} onChange={e => setNuova(p => ({ ...p, dpi: e.target.value }))}>
              <option value="203">203</option><option value="300">300</option><option value="600">600</option>
            </select>
          </div>
          <button className="btn-primary" disabled={!nuova.nome || !nuova.host || createMut.isPending} onClick={() => createMut.mutate()}>Salva</button>
        </div>
      )}

      <div className="card overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-slate-50 text-xs text-slate-500 uppercase">
              <th className="text-left px-3 py-2">Nome</th>
              <th className="text-left px-3 py-2">Host</th>
              <th className="text-left px-3 py-2">DPI</th>
              <th className="text-left px-3 py-2">Predefinita</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {isLoading && <tr><td colSpan={5} className="text-center py-8 text-slate-400">Caricamento...</td></tr>}
            {stampanti.map((s: any) => (
              <tr key={s.id} className="border-t border-slate-100">
                <td className="px-3 py-2">{s.nome}</td>
                <td className="px-3 py-2 font-mono">{s.host}:{s.porta}</td>
                <td className="px-3 py-2">{s.dpi}</td>
                <td className="px-3 py-2">{s.predefinita ? '★' : '—'}</td>
                <td className="px-3 py-2 flex gap-2">
                  <button className="btn-ghost text-xs flex items-center gap-1" onClick={() => testMut.mutate(s.id)}><Printer size={13} /> Test</button>
                  <button onClick={() => confirmDelete('Eliminare la stampante?', () => deleteMut.mutate(s.id))} className="text-red-500"><Trash2 size={14} /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {ConfirmModal}
    </div>
  )
}
